// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_dr-a";
export var fulfillmentFormRail = "_dr-9";
export var headerTitleRow = "_dr-c";
export var orderDetailsWrapper = "_dr-7";
export var orderLinkTrigger = "_dr-2";
export var paymentInformationGrid = "_dr-h";
export var paymentSummaryColumn = "_dr-i";
export var shipmentContainer = "_dr-b";
export var shipmentDetailsMainPane = "_dr-8";
export var shipmentNavigationCard = "_dr-5";
export var shipmentNavigationRail = "_dr-3";
export var shipmentNavigationRailHeader = "_dr-4";
export var shipmentSummaryFact = "_dr-e";
export var shipmentSummaryGrid = "_dr-d";
export var shipmentSummaryMetadataRow = "_dr-f";
export var shipmentSummaryTags = "_dr-g";
export var shipmentWorkspace = "_dr-0";
export var shipmentWorkspaceContent = "_dr-6";
export var shipmentWorkspaceHeader = "_dr-1";